import { Route } from 'react-router-dom'

export const mapRoutes = routes => routes.map(route => <Route key={route.name} {...route} />)
